import ModelsSelect from './ModelsSelect'

export default ModelsSelect;